import i18n from 'src/i18n';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'code',
            label: i18n.t('common_words.code'),
            sortable: true,
        },
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'farm.name',
            label: i18n.t('common_words.farm'),
            minWidth: 150,
            sortable: true,
        },
    ];
    
    return { tableColumns };
}
export default configTable;